import PropTypes from 'prop-types';
import lazyGettext from 'js-utils/lazy-gettext';

export const EVENT_CARD_SHARE_OPTIONS_PROPTYPE = PropTypes.shape({
    /*
    * Formatted url with utm term/campaign/content/source, etc included
    */
    eventUrl: PropTypes.string,
    /*
    * Affiliate tracking to be included in the share link
    */
    trackingCode: PropTypes.string,
    /*
    * Extra UTM options
    */
    utmOptions: PropTypes.object,
    /*
    * URL of the current server
    */
    serverUrl: PropTypes.string,
    /*
    * EB Twitter handle
    */
    twitterHandle: PropTypes.string,
    /*
    * If client is mobile
    */
    isMobile: PropTypes.bool,
    /*
    * Facebook specific share options
    */
    facebookOptions: PropTypes.shape({
        page: PropTypes.string,
        locale: PropTypes.string,
        appId: PropTypes.string,
        version: PropTypes.string,
        xfbml: PropTypes.bool,
    }),
});

export const EVENTBRITE = 'Eventbrite';
export const MANUAL = 'Manual';
export const SHARE_BY_COPY = 'copy';
export const FREE_FLAG_TEXT = lazyGettext('Free');
export const EVENT_TITLE_MAX_LENGTH = 75;
export const MOMENT_DATE_AND_TIME_FORMAT_STRING = 'ddd, MMM D, h:mma';
export const MOMENT_DATE_FORMAT_STRING = 'ddd, MMM D';

const FALLBACK_IMAGE_1 = '/static/images/search/placeholder1.png';
const FALLBACK_IMAGE_2 = '/static/images/search/placeholder2.png';
const FALLBACK_IMAGE_3 = '/static/images/search/placeholder3.png';
const FALLBACK_IMAGE_4 = '/static/images/search/placeholder4.png';
const FALLBACK_IMAGE_5 = '/static/images/search/placeholder5.png';
const FALLBACK_IMAGE_6 = '/static/images/search/placeholder6.png';

export const FALLBACK_IMAGE_LIST = [
    FALLBACK_IMAGE_1,
    FALLBACK_IMAGE_2,
    FALLBACK_IMAGE_3,
    FALLBACK_IMAGE_4,
    FALLBACK_IMAGE_5,
    FALLBACK_IMAGE_6,
];
